query betTickerEventSearch(
  $orderBy: [EventsOrderBy!] = [STARTS_AT_ASC]
  $condition: EventCondition
  $selectedEventsfilter: EventFilter
  $filter: EventFilter
  $includeSelectedEvents: Boolean! = false
) {
  selectedEvents: allEvents(
    orderBy: $orderBy
    filter: $selectedEventsfilter
    first: 10
  ) @include(if: $includeSelectedEvents) {
    nodes {
      eventId
      eventName
      startsAt
      isUsaView
      competition {
        competitionId
        competitionName
      }
    }
  }
  events: allEvents(
    orderBy: $orderBy
    condition: $condition
    filter: $filter
    first: 10
  ) {
    nodes {
      eventId
      eventName
      startsAt
      isUsaView
      competition {
        competitionId
        competitionName
      }
    }
  }
}
